export default __webpack_public_path__ + "icon_steering_wheel.0341f4381edcc77644ffd6709430c6af.svg";